import * as React from "react";
import { CTA } from "@volkswagen-onehub/components-core";
import { useNavigate } from "react-router";
function Link(props) {
    const navigate = useNavigate();
    const { path, text } = props;
    const onClick = (e) => {
        navigate(path);
        e.preventDefault();
    };
    return (React.createElement(CTA, { tag: "a", href: path, emphasis: "tertiary", onClick: onClick }, text));
}
export { Link };
